var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"48c70478cb45c64f5bc75f88fb8f0b7ce8ee6866"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"48c70478cb45c64f5bc75f88fb8f0b7ce8ee6866"};
      